import type { Configuration } from "@azure/msal-browser";
import { LogLevel } from "@azure/msal-browser";
import logger from "@/lib/logger";

export const scopes = [
  import.meta.env.VITE_AUTH_SCOPE,
];

export const config: Configuration = {
  // required
  auth: {
    // must match info in dashboard
    clientId: import.meta.env.VITE_AUTH_CLIENT_ID,
    authority: import.meta.env.VITE_AUTH_AUTHORITY,
    knownAuthorities: [import.meta.env.VITE_AUTH_AUTHORITY],

    // login redirect after popup close; must match path in dashboard
    redirectUri: "/redirect.html",
  },

  cache: {
    cacheLocation: "sessionStorage",
  },

  // optional
  system: {
    loggerOptions: {
      logLevel: LogLevel.Error,
      loggerCallback,
    },
  },
};

function loggerCallback (level: LogLevel, message: string, containsPii: boolean) {
  if (!containsPii) {
    const parts = message.split(" : ");
    const text = parts.pop();
    switch (level) {
      case LogLevel.Error:
        return logger.error(text);

      case LogLevel.Warning:
        return logger.warn(text);

      case LogLevel.Info:
        return logger.info(text);

      case LogLevel.Verbose:
        return logger.debug(text);
    }
  }
}
